import clsx from "clsx"
import { FC, PropsWithChildren } from "react"
import { Modal } from "@/ui/Modal"
import styles from "./ModalFullscreen.module.scss"
import { IModalFullscreen } from "./types"

export const ModalFullscreen: FC<PropsWithChildren<IModalFullscreen>> = ({
  children,
  onClose: _onClose,
  ...props
}) => {
  const {
    type: _type,
    className,
    body,
    isCanClose: _isCanClose,
    ...restProps
  } = props

  return (
    <Modal.Wrapper {...props}>
      <div className={clsx(styles.ModalFullscreen, className)} {...restProps}>
        <div
          {...body}
          className={clsx(styles.ModalFullscreen_body, body?.className)}
        >
          {children}
        </div>
      </div>
    </Modal.Wrapper>
  )
}
